
import Vue from 'vue'
export default Vue.extend({
  name: 'ModalComponent',
  props: {
    heading: String,
    id: String,
  },
  methods: {
    openpopup() {
      const modal = document.getElementById(this.id)
      if (!modal) {
        return
      }
      document.body.appendChild(modal)

      modal.style.display = "flex"

      // Get the <span> element that closes the modal
      const closeButton = document.getElementById(this.id + '_close')
      if (!closeButton) {
        return
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = (event: Event) => {
        if (event.target == modal) {
          this.emitClose()
        }
      }
    },
    emitClose() {
      const modal = document.getElementById(this.id)
      if (!modal) {
        return
      }
      modal.style.display = "none"
      this.$emit('close')
    }
  }
})
